import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, AgrDialogModule } from '@next/core-lib/dialog';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Subject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './one-day-delivery-help-dialog.component.html',
  imports: [AgrDialogModule, AgrI18nSharedModule],
})
export class OneDayDeliveryHelpDialogComponent extends AbstractDialog<AbstractDialogData> implements OnDestroy {
  readonly destroy$ = new Subject<void>();

  constructor(
    protected mdDialogRef: MatDialogRef<OneDayDeliveryHelpDialogComponent, AbstractDialogResultData<AbstractDialogData>>,
    @Inject(MAT_DIALOG_DATA) public data: AbstractDialogData,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
